import { inject, Injectable, OnDestroy } from '@angular/core';
import { IPasswordChangeRequest } from '@epicuro-next/data/users';
import {
  resetPassword,
  resetPasswordFailed,
} from '@epicuro-next/state/user-state';
import { ofType } from '@ngrx/effects';
import { ActionsSubject, Store } from '@ngrx/store';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Injectable()
export class ResetPasswordComponentStore implements OnDestroy {
  private store = inject(Store);
  private actions = inject(ActionsSubject);

  public error$ = new BehaviorSubject<string | null>(null);
  private destroy$ = new Subject<void>();

  constructor() {
    this.subscribeLoginFail();
  }

  public resetPassword(payload: IPasswordChangeRequest) {
    this.error$.next(null);
    this.store.dispatch(resetPassword({ payload }));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeLoginFail() {
    this.actions
      .pipe(ofType(resetPasswordFailed), takeUntil(this.destroy$))
      .subscribe(({ errors }) => {
        this.error$.next(errors[0]);
      });
  }
}
